import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";
import { I18n } from "aws-amplify/utils";
const ConfirmDeleteDialog = ({ open, onClose, onConfirm, parent }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {parent === "account_assignment"
          ? I18n.get("Delete Account Assignment")
          : parent === "map_email" ?
          I18n.get("Delete Email Mapping")
          : parent === "closure_rule"
          ? I18n.get("Delete Closure Rule")
          : I18n.get("Delete Alarm Type")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {parent === "account_assignment"
            ? I18n.get(
                "Are you sure you want to delete this account Assignment?"
              )
            : parent === "map_email" 
            ? I18n.get(
                "Are you sure you want to delete this email mapping?"
              )
            : parent === "closure_rule"
            ? I18n.get(
                "Are you sure you want to delete this closure rule?"
              )
            : I18n.get(
                "Are you sure you want to delete this alarm type? Deleting it will also remove all alarm texts mapped to this alarm type."
              )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {I18n.get("Cancel")}
        </Button>
        <Button onClick={onConfirm} color="primary" autoFocus>
          {I18n.get("Confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteDialog;
